import ctl from '@netlify/classnames-template-literals';

const underlineStyle = ctl(`
  before:rounded-b-md
  before:border-[1px]
  before:border-light-slate-gray
  before:w-full 
  before:h-[2px]
  before:absolute 
  before:block 
  before:bottom-0 
  before:left-0 
`);

export const linkStyle = ctl(`
  relative 
  px-1
  pb-1
  text-waterspout 
  font-[500]
`);

export const listStyle = ctl(`
  flex
  gap-6
`);

export const activeLinkStyle = ctl(`${linkStyle} ${underlineStyle}`);
